/**
 * ImagesLoaded.js
 */

import $ from 'jquery';
import imagesLoaded from 'imagesloaded';

export default class ImagesLoaded {

    constructor() {

        imagesLoaded($('.lazy-load'), function() {
            $(this.elements).each((index, el)=> {
                el.classList.add('loaded')
            })
        })

    }

}
